package com.milta.core.localization.translations.en

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Login",
    logout = "Logout",
    email = "Email",
    password = "Password",
    showPassword = "Show",
    hidePassword = "Hide",
    roleSelectionTitle = "Create an account",
    roleSelectionSubtitle = "Choose the account type that matches your profile",
    roleDriverTitle = "I am a driver - deliverer",
    roleDriverDescription = "I drive a transport or delivery vehicle and want to optimize my rounds",
    roleDriverTag1 = "Optimize my rounds",
    roleDriverTag2 = "Milta deals on my route",
    roleEnterpriseTitle = "I am a company",
    roleEnterpriseDescription = "I have a VAT number and manage a fleet of vehicles and a team of drivers",
    roleEnterpriseTag1 = "Fleet management",
    roleEnterpriseTag2 = "Team tracking",
    continueButton = "Continue",
    registerFormTitle = "Complete your registration",
    registerFormSubtitle = "Confirm your phone number to activate your account.",
    registerFormSubtitleEnterprise = "Enter your organisation and a phone number to activate your account.",
    googleAccountConnected = "Google account connected",
    appleAccountConnected = "Apple account connected",
    firstName = "First name",
    lastName = "Last name",
    phoneNumber = "Phone number",
    phoneNumberHelper = "Enter the phone number of your choice.",
    phoneNumberOtpInfo = "A verification code will be sent by SMS to confirm this number.",
    registerButton = "Receive a verification code",
    passwordHint = "At least 8 characters",
    registerSuccess = "Account created successfully",
    errorEmailConflict = "This email address is already in use",
    errorPhoneConflict = "This phone number is already registered",
    errorGeneric = "Connection failed. Check your network and try again.",
    errorFirstNameRequired = "Please enter your first name",
    errorFirstNameTooLong = "First name cannot exceed 100 characters",
    errorLastNameRequired = "Please enter your last name",
    errorLastNameTooLong = "Last name cannot exceed 100 characters",
    errorPhoneTooLong = "Phone number cannot exceed 20 characters",
    errorOAuthAccountExists = "This account is already linked to another Milta account. Try signing in instead.",
    errorOAuthTokenInvalid = "Your session has expired. Please sign in again.",
    loginTitle = "Sign in",
    loginTabPassword = "Password",
    loginTabPhone = "Phone number",
    loginButton = "Sign in",
    forgotPassword = "Forgot password?",
    sendCodeButton = "Send code",
    otpTitle = "Enter the code",
    otpSubtitle = "We sent a 6-digit code to",
    otpVerifyButton = "Verify",
    otpResend = "Resend code",
    otpResendPrefix = "Didn't receive the code?",
    otpWrongNumber = "Wrong number?",
    otpModifyLink = "Edit",
    forgotPasswordTitle = "Forgot password",
    forgotPasswordSubtitle = "Enter your email address to receive a reset link",
    forgotPasswordButton = "Send reset link",
    forgotPasswordSuccess = "Check your inbox",
    resetPasswordTitle = "New password",
    resetPasswordSubtitle = "Choose a new password for your account",
    resetPasswordNewLabel = "New password",
    resetPasswordConfirmLabel = "Confirm password",
    resetPasswordButton = "Reset password",
    resetPasswordSuccess = "Password reset. You can now sign in.",
    errorPasswordTooShort = "Password must be at least 8 characters",
    errorPasswordTooLong = "Password cannot exceed 128 characters",
    errorPasswordMismatch = "Passwords do not match",
    errorTokenInvalid = "This reset link is invalid or has expired. Request a new one.",
    errorEmailInvalid = "Please enter a valid email address",
    errorPhoneRequired = "Please enter a phone number",
    errorInvalidCredentials = "Wrong email or password. Use 'Forgot password?' if needed.",
    errorInvalidOtp = "Wrong code. Check your SMS or request a new one.",
    errorExpiredOtp = "Code expired. Request a new one.",
    errorTooManyAttempts = "Too many failed attempts. Try again in a few minutes.",
    errorResendLimit = "Too many resend requests. Try again in a few minutes.",
    otpResendIn = "Resend in %d s",
    otpAttemptsLeft = "%d attempts remaining",
    loginGreeting = "Welcome back!",
    loginSubtitle = "Sign in to your Milta account",
    loginSmsOption = "Receive an SMS code",
    noAccount = "Don't have an account?",
    signUp = "Sign up",
    organizationName = "Organisation name",
    organizationNameRequired = "Please enter the organisation name",
    registerNextButton = "Next",
    passwordConfirm = "Confirm password",
    passwordRuleUpper = "One uppercase letter",
    passwordRuleDigit = "One digit",
    passwordRuleSpecial = "One special character",
    alreadyHaveAccount = "Already have an account — Sign in",
)
